import * as React from "react";
import { Pressable, StyleSheet, View } from "react-native";
import fixture from "./__test__/fixture.json";
import { Text, useTheme } from "react-native-paper";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { Block } from "@block";
import { StackActions, useNavigation } from "@react-navigation/native";
import ScreenNameType from "@navigation/nav-screens";
import { useTranslation } from "react-i18next";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { spacing } from "@styles/spacing";
import { useDesktopMediaQuery } from "@media-query";
import IconsYellowBanking from "app/shared/components/icons/icon-yellow-banking/IconsYellowBanking";
import { ScrollView } from "react-native-gesture-handler";
import { StackSpacing } from "@components/spacing";
import { globalShowFuture } from "app/shared/util/future";
import Animated, { useAnimatedStyle, withSpring } from "react-native-reanimated";
import { useDispatch, useSelector } from "react-redux";
import { setTermOpenReset } from "../term-deposit-open/reducer/actions";
import { setTermStatementReset } from "../term-deposit-statement/reducer/actions";
import { setTermTopUpReset } from "../term-deposit-top-up/reducer/actions";
import { getContactIdSelector } from "app/modules/account-management/reducer/selectors";
import { pushCleverTapEvent } from "app/shared/util/app-flyer";

type PressAbleState = Readonly<{
  pressed: boolean;
  hovered?: boolean;
  focused?: boolean;
}>;

const ListFunctionTermDeposit = () => {
  const { colors, fonts } = useTheme();
  const { t, i18n } = useTranslation();
  const { dispatch } = useNavigation();
  const dispatchStore = useDispatch();

  const isDesktop = useDesktopMediaQuery();
  const contactId = useSelector(getContactIdSelector);

  const onCancel = () => {
    dispatch(StackActions.replace(ScreenNameType.HOME));
  };

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        textName: { ...fonts.medium, color: colors.text, textAlign: "center", maxWidth: 164, alignSelf: "center" },
      }),
    [colors.text, fonts.medium],
  );

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => onCancel(),
    },
    {
      name: t("FUNC_TIET_KIEM"),
      onPressSubtitle: () => {},
    },
  ];

  const onPressItems = (index: number | string) => {
    switch (index) {
      case 0:
        eventPushCleverTap("Danh sách", "success");
        dispatch(StackActions.replace(ScreenNameType.LIST_TERM_DEPOSIT));
        break;
      case 1:
        eventPushCleverTap("Mở sổ", "success");
        dispatchStore(setTermOpenReset());
        dispatch(StackActions.replace(ScreenNameType.TERM_DEPOSIT_OPEN_CREATE, { resetData: true }));
        break;
      case 2:
        eventPushCleverTap("Nộp thêm", "success");
        dispatchStore(setTermTopUpReset());
        dispatch(StackActions.replace(ScreenNameType.TERM_DEPOSIT_TOP_UP_CREATE, { resetData: true }));
        break;
      case 3:
        eventPushCleverTap("Tất toán", "success");
        dispatchStore(setTermStatementReset());
        dispatch(StackActions.replace(ScreenNameType.TERM_DEPOSIT_STATEMENT_CREATE, { resetData: true }));
        break;
      default:
        globalShowFuture();
        break;
    }
  };

  const eventPushCleverTap = (cta?: string,response?: string) => {
    const { eventNameCT, paramsCT } = handlerParamsCleverTap(cta, response);
    pushCleverTapEvent(eventNameCT, paramsCT);
  };

  const handlerParamsCleverTap = (cta?: string, response?: string) => {
    console.log("handlerParamsCleverTap");
    //Nộp thêm | Tất toán | Trang chủ | Mở sổ | Danh sách
    let param = {};
    param = {
      ct_channel: "ib_rb",
      ct_cccd_ID: contactId,
      ct_list_deposit_status: response || "",
      ct_cta: cta || "",
    };

    return {
      eventNameCT: "ct_list_of_deposit",
      paramsCT: param,
    };
  };

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("FUNC_TIET_KIEM")} subtitles={subtitlesArrays} />
        <Block pv={spacing.medium} ph={isDesktop ? "5%" : 0}>
          <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
            {fixture.funcitons[0].children.map((_item, _index) => (
              <View key={_index} style={[{ maxWidth: isDesktop ? "25%" : "50%", minWidth: isDesktop ? "25%" : "50%" }]}>
                <Pressable style={{ alignSelf: "center" }} onPress={() => onPressItems(_index)} key={_index}>
                  {({ hovered }: PressAbleState) => {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    const _buttonStyle = useAnimatedStyle(() => {
                      return {
                        justifyContent: "center",
                        alignItems: "center",
                        transform: [
                          {
                            scale: hovered ? withSpring(1.06) : withSpring(1),
                          },
                        ],
                      };
                    });
                    return (
                      <Animated.View style={_buttonStyle}>
                        <Block br={20} p={spacing.huge} bg={colors.backgroundForm} middle center>
                          <IconsYellowBanking name={_item.icon} size={64} />
                        </Block>
                        <StackSpacing size="small" />
                        <Text numberOfLines={2} style={styles.textName}>
                          {i18n.language === "vi" ? _item.name.vi : _item.name.en}
                        </Text>
                        <StackSpacing size="huge" />
                      </Animated.View>
                    );
                  }}
                </Pressable>
              </View>
            ))}
          </View>
        </Block>
      </ScrollView>
    </Block>
  );
};

export default ListFunctionTermDeposit;
